import { cn } from "@/lib/utils";
import { getFileRecordIconInfo } from "../../../lib/file-icon";

export interface FileRecordTypeIconProps {
  contentType: string;
  /** Pass `record.origin_type` to override the icon for URL-ingested records
   *  — e.g. Globe for Firecrawl-scraped webpages ("webpage"). */
  originType?: string | null;
  className?: string;
}

/**
 * Renders a coloured file-type icon for a file record.
 *
 * Colours come from `--file-*` tokens (`text-file-image`, `text-file-pdf`, …)
 * in cohesive-theme.css. Webpage origins (`originType === "webpage"`) use
 * `text-file-webpage` + Globe regardless of MIME type.
 */
export function FileRecordTypeIcon({
  contentType,
  originType,
  className,
}: FileRecordTypeIconProps) {
  const { icon: Icon, color } = getFileRecordIconInfo(contentType, originType);
  return (
    <Icon className={cn(color, "shrink-0", className)} strokeWidth={1.75} />
  );
}
